import { configureApiEntity } from '../adapter/index';
import { schema } from 'normalizr';

export const productMenuGroupSchema = new schema.Entity('productMenuGroups');

export const productMenuGroups = configureApiEntity('PRODUCTMENUGROUPS', 'productMenuGroups', productMenuGroupSchema);
